import {ErrorMessage, Field} from 'formik';
import {useState} from 'react';
import PhoneInput from '../components/PhoneInput';

const PhoneStep = ({formik, onBack}) => {
  const [showDropdown, setShowDropdown] = useState(false);

  const countries = [
    {code: 'US', name: 'United States', dialCode: '+1'},
    {code: 'GB', name: 'United Kingdom', dialCode: '+44'},
    {code: 'CA', name: 'Canada', dialCode: '+1'},
    {code: 'AU', name: 'Australia', dialCode: '+61'},
    {code: 'DE', name: 'Germany', dialCode: '+49'},
    {code: 'FR', name: 'France', dialCode: '+33'},
    {code: 'JP', name: 'Japan', dialCode: '+81'},
    {code: 'CN', name: 'China', dialCode: '+86'},
    {code: 'IN', name: 'India', dialCode: '+91'},
    {code: 'BR', name: 'Brazil', dialCode: '+55'},
  ];
  const [dialCode, setDialCode] = useState(countries[0].dialCode);
  const [contryCode, setContryCode] = useState(countries[0].code);

  const handleCountrySelect = (code) => {
    setDialCode(code.dialCode);
    setContryCode(code.code);
    setShowDropdown(false);
  };

  return (
    <div className="registration-form">
      <h2 className="text-white" style={{fontSize: '20px'}}>
        Enter Mobile Number
      </h2>
      <p className="text-white-50 mb-3" style={{fontSize: '10px'}}>
        Verify your mobile number
      </p>

      <div className="input-group mb-1 gap-2">
        <span
          className="input-group-text bg-dark text-white border-0 rounded-2 px-2 gap-2"
          style={{fontSize: '12px', cursor: 'pointer'}}
          onClick={() => {
            setShowDropdown(!showDropdown);
          }}
        >
          <img
            src={`https://flagcdn.com/w20/${contryCode.toLowerCase()}.png`}
            className=""
            alt={contryCode}
            // style={}
          />
          {dialCode}
        </span>

        <Field
          type="tel"
          name="phone"
          className="form-control bg-dark text-white border-0 py-3 rounded-2"
          placeholder="123 456 7890"
        />
      </div>

      <div style={{position: 'relative'}}>
        {showDropdown && (
          <div
            className="position-absolute start-0 rounded-3 py-2"
            style={{
              backgroundColor: '#1E1E1E',
              width: '100%',
              maxHeight: '200px',
              overflowY: 'auto',
              zIndex: 100,
              boxShadow: '0 4px 12px rgba(0,0,0,0.2)',
            }}
          >
            {countries.map((country) => (
              <div
                key={country.code}
                className="d-flex align-items-center px-3 py-2"
                style={{cursor: 'pointer'}}
                onClick={() => handleCountrySelect(country)}
              >
                <img
                  src={`https://flagcdn.com/w20/${country.code.toLowerCase()}.png`}
                  alt={country.name}
                  style={{
                    width: '24px',
                    marginRight: '12px',
                  }}
                />
                <span className="text-white">{country.name}</span>
                <span className="text-secondary ms-auto">{country.dialCode}</span>
              </div>
            ))}
          </div>
        )}
      </div>

      <ErrorMessage
        name="phone"
        component="div"
        className="text-danger mb-3"
        style={{fontSize: '10px'}}
      />

      <div className="form-check mb-3 mt-3 flex justify-content-center align-items-center">
        <Field
          type="checkbox"
          name="receiveOffers"
          className="form-check-input"
          id="receiveOffers"
        />
        <p
          className="form-check-label text-white-50"
          htmlFor="receiveOffers"
          style={{fontSize: '9px', color: '#5B5B5B'}}
        >
          I'll like to receive an offers and updates from mapex.app
        </p>
      </div>

      <div className="d-flex gap-2">
        <button
          type="submit"
          className="btn btn-primary py-3 w-100"
          style={{
            backgroundColor: '#2E2CB2',
            border: 'none',
            fontSize: '13px',
          }}
          disabled={formik.isSubmitting}
        >
          {/* Receive Verification SMS */}
          {formik.isSubmitting ? <div className="loader" /> : ' Receive Verification Mail'}
        </button>
      </div>

      <p
        className="text-white-50 text-center small mt-3"
        style={{fontSize: '10px', lineHeight: '15px'}}
      >
        By According you email, you conform that{' '}
        <a href="#" className="text-primary">
          mapex.app
        </a>
      </p>
    </div>
  );
};

export default PhoneStep;
